var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarHd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14.5619L1 9.63882L4.05231 2.51513C4.24224 2.07206 4.5581 1.6945 4.96068 1.42932C5.36326 1.16414 5.83485 1.02301 6.31692 1.02344H15.3778C15.8595 1.02349 16.3305 1.16485 16.7326 1.43C17.1347 1.69515 17.4502 2.07244 17.64 2.51513L20.6923 9.63882V14.5619C20.6923 15.2147 20.433 15.8408 19.9713 16.3025C19.5097 16.7641 18.8836 17.0234 18.2308 17.0234H3.46154C2.8087 17.0234 2.1826 16.7641 1.72097 16.3025C1.25934 15.8408 1 15.2147 1 14.5619Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30919 12.7145C5.30919 12.0348 4.75816 11.4838 4.07843 11.4838C3.39869 11.4838 2.84766 12.0348 2.84766 12.7145C2.84766 13.3943 3.39869 13.9453 4.07843 13.9453C4.75816 13.9453 5.30919 13.3943 5.30919 12.7145Z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61719 9.64062L20.0787 9.64063",
    stroke: "#EFEFEF",
    strokeWidth: 1.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHd);
export default __webpack_public_path__ + "static/media/sidebar-hd.5667a264c705c982a8f2d48a2978e6a7.svg";
export { ForwardRef as ReactComponent };